import { pluralize } from "@therms/web-js";
//#region src/components/DateTime/utils/timeago-formatter.ts
var shortTimeFormatter = (value, unit, suffix) => {
	let str = `${value}`;
	if (unit === "second") str += `s`;
	else if (unit === "minute") str += `m`;
	else if (unit === "hour") str += `h`;
	else if (unit === "day") str += ` ${pluralize("day", value)}`;
	else if (unit === "week") str += ` ${pluralize("wk", value)}`;
	else if (unit === "month") str += ` ${pluralize("mth", value)}`;
	else if (unit === "year") str += ` ${pluralize("yr", value)}`;
	else str += ` ${unit}`;
	return str + ` ${suffix}`;
};
//#endregion
export { shortTimeFormatter };

//# sourceMappingURL=timeago-formatter.js.map